// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.VisualTypeMapping.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

export default {
  //izenda-value                //highchart-value
  Line: 'izendaLine',
  Column: 'column',
  Bar: 'bar',
  Area: 'izendaArea',
  Pie: 'pie',
  Funnel: 'funnel',
  Donut: 'donut',
  TreeMap: 'treemap',
  Combination: 'combination',
  HeatMap: 'heatmap',
  Bubble: 'bubble',
  Scatter: 'scatter',
  Waterfall: 'waterfall',
  Sparkline: 'sparkline',

  SolidGauge: 'izendaSolidGauge',
  LinearGauge: 'izendaLinearGauge',
  SimpleGauge: 'izendaSimpleGauge',
  Map: 'map'
};



// WEBPACK FOOTER //
// ./ui/share/components/charting/highcharts/Izenda.VisualTypeMapping.js